export const TABLE_COL_IDS = {
  SELECTION: 'selection',
  COMPANY_ID: 'companyId',
  TYPE: 'type',
  STATUS: 'isActive',
  ACTIONS: 'actions',
};

export const tableColumns = [
  {
    Header: '',
    accessor: TABLE_COL_IDS.SELECTION,
    width: '16px',
    disableSortBy: true,
  },
  {
    Header: 'חברה',
    accessor: TABLE_COL_IDS.COMPANY_ID,
    width: '150px',
  },
  {
    Header: 'סוג קמפיין',
    accessor: TABLE_COL_IDS.TYPE,
    width: '150px',
  },
  {
    Header: 'סטטוס',
    accessor: TABLE_COL_IDS.STATUS,
    width: '20px',
  },
  {
    Header: 'פעולות נוספות',
    accessor: TABLE_COL_IDS.ACTIONS,
    width: '80px',
    disableSortBy: true,
  },
];
